<template>
  <section class="ble-pass-content">
    <BlePassUploadPopup
      v-if="uploadPopup.opened"
      v-model="uploadPopup.modelValue"
      @close="onUploadPopupClose"
      @approveBlePass="onUploadPopupApprove"
    />
    <div class="ble-pass-content__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="ble-pass-content__list">
      <Table
        :columns="tableColumns"
        :rows="tableRows"
        :selectable="false"
        :clickable="false"
      />
      <Pagination
        v-model="blePassesMeta.current_page"
        v-bind="{
          totalItems: blePassesMeta.total,
          itemsByPage: blePassesMeta.per_page,
        }"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="ble-pass-content__actions">
      <Actions :actions="actions.default" />
    </div>
  </section>
</template>

<script>
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import Pagination from '../../components/Pagination.vue'
import BlePassUploadPopup from '../Popup/BlePassUpload.vue'
import MockBlePassList from '../../mixins/Mock/MockBlePassList.js'

export default {
  name: 'BlePassListContent',
  mixins: [MockBlePassList],
  components: {
    Filters,
    Table,
    Actions,
    Pagination,
    BlePassUploadPopup,
  },
  data() {
    return {
      filtersActive: {},
      uploadPopup: {
        opened: false,
        modelValue: {
          file: null,
        },
      },
    }
  },
  computed: {
    blePassesMeta() {
      return this.$store.getters['blePassesMeta']
    },
  },
  methods: {
    onUploadBlePass() {
      this.uploadPopup.opened = true
    },
    onUploadPopupClose() {
      this.uploadPopup.opened = false
      this.uploadPopup.modelValue = {
        file: null,
      }
    },
    onUploadPopupApprove(data) {
      this.$store.dispatch('setIsLoading', true)

      this.blePassService
        .uploadBlePasses(this.currentGateCuid, {
          organization_id: this.currentOrganizationId,
          file: data.file,
        })
        .then(async () => {
          this.$store.dispatch('setNotification', {
            text: 'BLE пропуска успешно загружены.',
            type: 'success',
          })

          this.onUploadPopupClose()
          await this.getFilteredBlePasses()
        })
        .catch(error => {
          console.log(error)
          this.$store.dispatch('setNotification', {
            text:
              error.response?.data?.message ||
              'Ошибка при загрузке BLE пропусков.',
            type: 'cross-outlined',
          })
        })
        .finally(() => {
          this.$store.dispatch('setIsLoading', false)
        })
    },
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterBlePasses({
          ...value,
          status: value.status ?? '',
        })
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.ble-pass-content {
  &__filters {
    margin: 0px $space-md $space-lg;
  }

  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
